import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ADD_SCHEDULE_RESERVE_SAGA } from "../sagaTypes";
import { loadingAction, setScheduleAction } from '../actions.js';
import { url } from "../../config";
import growl from "../../lib/growl/growl.js";
import { SCHEDULE_INITIAL } from "../initialStateConstants";

const request = data => {
    return fetch(`${ url }/add_schedule_res`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerAddScheduleReserve(args) {
    const est = yield select(state => state.est);
    const user = yield select(state => state.user);
    const schedule = yield select(state => state.schedule);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);
        formData.append('establishment', est.id);

        formData.append('date', schedule.date);
        formData.append('time', schedule.selected_time);
        formData.append('services', JSON.stringify(schedule.selected_services));
        formData.append('master', schedule.selected_master);

        const response = yield call (request, formData);

        if (response.success) {
            // Закрываем форму расписания
            yield put(setScheduleAction(SCHEDULE_INITIAL));

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherAddScheduleReserve() {
    yield takeLatest(ADD_SCHEDULE_RESERVE_SAGA, workerAddScheduleReserve);
}